import { Box, Button, TextField } from '@mui/material';
import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { postClient } from '../requests';
import { axiosWithToken } from '../../../utils/axios';

export const EditCustomerPage = () => {
  const { user } = useLoaderData() as any;
  const handleRegisterClick = () => {
    postClient({ company_name: 'テスト株式会社' });
  };

  const handleGETAlerts = () => {
    axiosWithToken.get('/alerts_lambda/');
  };

  return (
    <>
      <Box style={{ margin: '24px' }}>
        <Box margin="16px 0px">
          <div>ユーザー情報の登録</div>
          <TextField variant="standard" label="ユーザー名" />
        </Box>

        <Button variant="contained">送信</Button>
      </Box>

      <Box style={{ margin: '24px' }}>
        <Box margin="16px 0px">
          <div>会社情報</div>
          <TextField variant="standard" label="会社名" />
        </Box>

        <Button variant="contained" onClick={handleRegisterClick}>
          登録
        </Button>
      </Box>

      <Box style={{ margin: '24px' }}>
        <Box margin="16px 0px">
          <div>アラートのGET</div>
        </Box>

        <Button variant="contained" onClick={handleGETAlerts}>
          実行
        </Button>
      </Box>
    </>
  );
};
